// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1SLVu","footer":"ModalError_footer__3_9d2"};